// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Icon} from './../icon/Icon'

@Component({
    name: 'Message',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class Message extends Vue {

    public defaultIcon!: string

    /**
     * Das Theme der Nachricht (default oder secondary)
     */
    @Prop({default: 'default'})
    public theme!: 'default' | 'secondary'

    /**
     * Der Type der Nachricht (success, info oder error)
     */
    @Prop()
    public type!: "success" | "info" | "error"

    /**
     * Wenn value true wird die Nachricht angezeigt, wenn false nicht.
     *
     * Die Eigenschaft heißt value, damit sie auch mit v-model benutzt werden kann.
     */
    @Prop({default: true})
    public value!: boolean

    /**
     * Gibt ob man die Nachricht weg klicken kann.
     */
    @Prop({default: true})
    public closeable!: boolean

    @Watch('type')
    public watchType(type, oldType) {
        this.setDefaultIcon()
    }

    public created () {

        this.setDefaultIcon()
    }

    public setDefaultIcon() {

        switch (this.type) {

            case 'success':
                this.defaultIcon = this.$icons.CONFIRM
                break

            case 'info':
                this.defaultIcon = this.$icons.INFO
                break

            case 'error':
                this.defaultIcon = this.$icons.ERROR
                break
        }
    }

    public toggle(e: Event) {

        if (this.value) {
            this.$emit('input', false)
            this.$emit('close')
        } else {
            this.$emit('input', true)
        }
    }
}